import React from 'react'

import InvoiceOverlayModal from '../modals'
import Button, { ButtonSize, ButtonVariant } from '../ui/button'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isUpdating: boolean
  description: string
}

const TaxUpdateScopeModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isUpdating,
  description,
}) => {
  return (
    <InvoiceOverlayModal
      open={open}
      onClose={onClose}
      title='Update tax in previous invoices?'
      description={description}
    >
      <div className='d-flex justify-content-between pt-2'>
        <Button
          type='button'
          size={ButtonSize.SMALL}
          variant={ButtonVariant.LIGHT}
          onClick={onClose}
          disabled={isUpdating}
        >
          Keep previous invoices unchanged
        </Button>
        <Button
          type='button'
          size={ButtonSize.SMALL}
          loading={isUpdating}
          loadingText='Updating...'
          onClick={onConfirm}
          disabled={isUpdating}
        >
          Update all unsent invoices
        </Button>
      </div>
    </InvoiceOverlayModal>
  )
}

export default TaxUpdateScopeModal
